import { CommonPageWrapper, HeadingWrapper } from 'admin/components/wrappers';
import AdminCustomButton from 'app/components/AdminCustomButton';
import { AdminSearch } from 'app/components/AdminSearchField';
import CustomBreadCrumb from 'app/components/CustomBreadCrumb';
import { BlurredLabel, PageMainLabel } from 'app/components/SHLabel';
import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import TeamsTable from './TeamsTable';
import { useNavigateToRoute } from 'utils/common';
import useTeamApi from 'admin/hooks/useTeamApi';
import { useDebounce } from 'hooks/useDebounce';
import useCommonLookUpDatas from 'hooks/useCommonLookupData';
import { getLookupArray } from 'utils/common';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import AdminDropDown from 'app/components/AdminDropDown';
import { GeneralLookup } from 'services/openapi';
import { CommonLoader } from 'app/components/CommonLoader';
import { usePermission } from 'hooks/usePermission';
import Cookies from 'js-cookie';

export interface breadCrumbDataModel {
  id: string;
  text?: string;
}
const TeamsPage = () => {
  const { status } = useParams();
  const currentLocation = useLocation();
  const navigate = useNavigate();
  const isPastDataFlag = currentLocation.pathname.includes('past-data');
  const userType = Cookies.get('userType') ?? '';
  const breadCrumbItems = [
    {
      id: '',
      text: userType === 'COACH' ? 'Showyeda coach' : 'Showyeda admin',
      disabled: true,
    },
    {
      id: '',
      text: 'Teams',
      disabled: true,
    },
  ];
  const redirect = useNavigateToRoute();
  const { hasViewPermission } = usePermission();
  const {
    fetchManageGetTeams,
    teamProfileData,
    loading,
    deleteTeam,
    teamActiveOrInactive,
    handleDownloadTeam,
    downloadLoading,
  } = useTeamApi();
  const { getAllLookupData, lookUps } = useCommonLookUpDatas();
  // Initialize selectedItemId based on URL status parameter
  const getInitialSelectedItemId = () => {
    if (status === 'active') {
      return 'bc1e49f9-0f4a-4222-ba22-c4f4af0b4f75';
    } else if (status === 'inactive') {
      return 'f7f4cf58-a6fd-4646-9e25-d9517f92709e';
    }
    // No status param means show both (no filter)
    return null;
  };

  const [selectedItemId, setSelectedItemId] = useState<string | null>(getInitialSelectedItemId());
  const [paidFilter, setPaidFilter] = useState<number | null>(null);
  const [searchTerm, setSearchTerm] = useState<string>('');
  const [pageSkip, setPageSkip] = useState<number | undefined>(0);
  const debounceTeamSearch = useDebounce(searchTerm);
  const [breadcrumbPreData, setBreadcrumbPreData] =
    React.useState<breadCrumbDataModel[]>(breadCrumbItems);
  const [seasonPayload, setSeasonPayload] = React.useState<GeneralLookup>({
    id: '',
    name: '',
  });
  const [sortField, setSortField] = useState<string>('teamName');
  const [sortOrder, setSortOrder] = useState<number>(0);
  const [pageSize, setPageSize] = useState<number>(50);
  const [pageSizeSelected, setPageSizeSelected] = useState<GeneralLookup>({
    id: '50',
    name: '50',
  });

  // Page size options for the dropdown
  const pageSizeOptions: GeneralLookup[] = [
    { id: '25', name: '25' },
    { id: '50', name: '50' },
    { id: '100', name: '100' },
    { id: '200', name: '200' },
  ];
  // const [isOrder, setIsOrder] = useState(false);
  const handleItemIdClick = (itemId: string) => {
    const newSelectedItemId = itemId === selectedItemId ? null : itemId;
    setSelectedItemId(newSelectedItemId);
    const basePath = userType === 'COACH' ? '/coach' : '/admin';

    if (newSelectedItemId) {
      // A filter is selected
      let statusRoute = '';
      if (itemId === 'bc1e49f9-0f4a-4222-ba22-c4f4af0b4f75') {
        statusRoute = 'active';
      } else if (itemId === 'f7f4cf58-a6fd-4646-9e25-d9517f92709e') {
        statusRoute = 'inactive';
      }

      if (statusRoute) {
        const fullPath = isPastDataFlag
          ? `${basePath}/past-data/teams/${statusRoute}`
          : `${basePath}/teams/${statusRoute}`;
        navigate(fullPath, { replace: true });
      }
    } else {
      // No filter selected (deselected) - navigate to base path (shows both)
      const fullPath = isPastDataFlag
        ? `${basePath}/past-data/teams`
        : `${basePath}/teams`;
      navigate(fullPath, { replace: true });
    }
    fetchManageGetTeams(
      debounceTeamSearch,
      newSelectedItemId ?? '',
      '',
      sortField,
      sortOrder,
      0,
      pageSize,
      paidFilter as number,
    );
  };
  const handleSearch = e => {
    setSearchTerm(e.target.value);
  };
  const handleNewTeam = () => {
    redirect(
      userType === 'COACH'
        ? `/coach/teams/add/profile-info`
        : `/admin/teams/add/profile-info`,
    );
  };

  const handleDropdownChange = (data: GeneralLookup) => {
    setSeasonPayload(data);
    fetchManageGetTeams(
      debounceTeamSearch,
      selectedItemId ?? '',
      data?.id,
      sortField,
      sortOrder,
      0,
      pageSize,
    );
  };
  const handleTeamDwoload = async () => {
    try {
      const url: any = await handleDownloadTeam(
        debounceTeamSearch,
        selectedItemId ?? '',
        seasonPayload?.id,
        sortField,
        sortOrder,
        paidFilter as number,
      );

      // Extract filename from URL
      const filename = url.split('/').pop();

      fetch(url)
        .then(response => response.blob())
        .then(blob => {
          const objectUrl = URL.createObjectURL(blob);

          const link = document.createElement('a');
          link.href = objectUrl;
          link.download = filename!; // Use the extracted filename

          // Append link to body (required for Firefox)
          document.body.appendChild(link);

          // Trigger download
          link.click();

          // Clean up
          document.body.removeChild(link);
          URL.revokeObjectURL(objectUrl);
        })
        .catch(error => {
          console.error('Error downloading file:', error);
        });

      return url;
    } catch (error) {
      console.error('Error downloading team point report:', error);
      throw error;
    }
  };
  useEffect(() => {
    if (debounceTeamSearch.length > 0) {
      fetchManageGetTeams(
        debounceTeamSearch,
        selectedItemId ?? '',
        '',
        sortField,
        sortOrder,
        0,
        pageSize,
        paidFilter as number,
      );
    } else if (status) {
      // Use URL status parameter if provided
      const activeStatusId =
        status === 'active'
          ? 'bc1e49f9-0f4a-4222-ba22-c4f4af0b4f75'
          : 'f7f4cf58-a6fd-4646-9e25-d9517f92709e';
      setSelectedItemId(activeStatusId);
      fetchManageGetTeams(
        debounceTeamSearch,
        activeStatusId,
        '',
        sortField,
        sortOrder,
        0,
        pageSize,
        paidFilter as number,
      );
    } else {
      // Default to Active status when no status param
      fetchManageGetTeams(
        debounceTeamSearch,
        selectedItemId ?? "",
        '',
        sortField,
        sortOrder,
        0,
        pageSize,
        paidFilter as number,
      );
    }
  }, [debounceTeamSearch, status]);

  // Effect to sync selectedItemId with URL status parameter
  useEffect(() => {
    if (status) {
      const activeStatusId =
        status === 'active'
          ? 'bc1e49f9-0f4a-4222-ba22-c4f4af0b4f75'
          : status === 'inactive'
            ? 'f7f4cf58-a6fd-4646-9e25-d9517f92709e'
            : null;
      setSelectedItemId(activeStatusId);
    }
  }, [status]);

  useEffect(() => {
    getAllLookupData('ACTIVESTATUS,SEASON');
  }, []);
  return (
    <>
      <CommonPageWrapper>
        {downloadLoading && <CommonLoader loaderType="main" />}
        <HeadingWrapper>
          <PageMainLabel>Teams</PageMainLabel>
          <CustomBreadCrumb
            preData={breadcrumbPreData}
            setPreData={setBreadcrumbPreData}
          />
        </HeadingWrapper>
        <HeadingWrapper>
          <ButtonWrapper>
            {hasViewPermission('0200101002') && (
              <>
                {!isPastDataFlag && (
                  <AdminCustomButton
                    buttonType="primary"
                    isActive={false}
                    className="fill-button"
                    onClick={handleNewTeam}
                  >
                    Add Team
                  </AdminCustomButton>
                )}
              </>
            )}

            <BlurredLabel style={{ whiteSpace: 'nowrap' }}>
              Popular filter
            </BlurredLabel>
            {getLookupArray('ACTIVESTATUS', lookUps).map(item => (
              <AdminCustomButton
                key={item.id}
                buttonType="primary"
                isActive={false}
                className={
                  selectedItemId?.includes(item?.id)
                    ? 'active-inactive'
                    : 'Inactive-button'
                }
                onClick={() => {
                  handleItemIdClick(item?.id);
                }}
              >
                {item?.name}
              </AdminCustomButton>
            ))}
            {isPastDataFlag && (
              <CustomDropDown
                label=""
                placeholder="Select season"
                onDataChange={data => handleDropdownChange(data)}
                defaultValue={seasonPayload}
                data={getLookupArray('SEASON', lookUps)}
                className="field-style"
                popupStyles="medium-dropdown"
              />
            )}
          </ButtonWrapper>
          <div className="search-wrapper">
            {/* {isPastDataFlag && ( */}
            <AdminCustomButton
              buttonType="primary"
              isActive={false}
              className="fill-button"
              onClick={handleTeamDwoload}
              disabled={teamProfileData?.teams?.length === 0}
            >
              Download
            </AdminCustomButton>
            {/* )} */}

            <div style={{ width: '283px', paddingTop: '30px' }}>
              <AdminSearch
                placeholder="Search by team name, id or coach"
                onSearchTextEntering={handleSearch}
                searchTerm={searchTerm}
                setSearchTerm={setSearchTerm}
              />
            </div>
          </div>
        </HeadingWrapper>
        {(teamProfileData?.pageDetails?.count ?? 0) > 25 && (
          <EntriesPerPageDropDownWrapper>
            <AdminDropDown
              label="No: of entries per page"
              placeholder="Select entries"
              onDataChange={(data: GeneralLookup) => {
                const newPageSize = parseInt(data.id, 10);
                setPageSize(newPageSize);
                setPageSizeSelected(data);
                setPageSkip(0);
                fetchManageGetTeams(
                  debounceTeamSearch,
                  selectedItemId ?? '',
                  '',
                  sortField,
                  sortOrder,
                  0,
                  newPageSize,
                  paidFilter as number,
                );
              }}
              defaultValue={pageSizeSelected}
              data={pageSizeOptions}
              className="entries-dropdown-style"
              popupStyles="entries-dropdown-popup"
            />
          </EntriesPerPageDropDownWrapper>
        )}
        {/* Teams Table */}
        {hasViewPermission('0200101001') && (
          <TeamsTable
            teamProfileData={teamProfileData}
            setPageSkip={setPageSkip}
            pageSkip={pageSkip}
            fetchManageGetTeams={fetchManageGetTeams}
            debounceTeamSearch={debounceTeamSearch}
            teamActiveOrInactive={teamActiveOrInactive}
            deleteTeam={deleteTeam}
            selectedItemId={selectedItemId}
            lookup={getLookupArray('ACTIVESTATUS', lookUps)}
            sortField={sortField}
            sortOrder={sortOrder}
            setSortField={setSortField}
            setSortOrder={setSortOrder}
            loading={loading}
            paidFilter={paidFilter}
            pageSize={pageSize}
            pageSizeSelected={pageSizeSelected}
          />
        )}
      </CommonPageWrapper>
    </>
  );
};

export default TeamsPage;
const ButtonWrapper = styled.div`
  display: flex;
  gap: 10px;
  padding: 30px 0 0;
  .field-style {
    display: flex;
  }
  .k-dropdownlist {
    max-height: 31px;
  }
`;
const CustomDropDown = styled(AdminDropDown)`
  width: 160px;
  .k-dropdownlist {
    max-height: 31px;
    border-radius: 8px !important;
  }
  .k-input-inner {
    padding: 0 5px !important;
  }
  .k-input-value-text {
    margin: 2px 4px 2px 4px;
    font-size: 12px !important;
    letter-spacing: 0px;
    color: #1e1e1e;
    text-align: left;
  }
`;
const EntriesPerPageDropDownWrapper = styled.div`
  display: flex;
  align-items: flex-start;
  padding-top: 10px;
  .SHdropdown {
    width: 160px;

    .label {
      margin-bottom: 8px;
      font-size: 13px;
      color: #475467;
      font-weight: 500;
    }

    .k-dropdownlist {
      max-height: 38px;
      border-radius: 8px !important;
    }

    .k-input-inner {
      padding: 0 8px !important;
      font-size: 13px;
    }

    .k-input-value-text {
      margin: 4px 0;
      font-size: 13px !important;
      color: #1e1e1e;
    }
  }
`;
